import React, { useEffect } from "react";

// ui components
import "react-datepicker/dist/react-datepicker.css";

import styled from "styled-components";
import { RootState } from "../../store/rootReducer";
import { useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { JenisDokumen, JenisDokumenRequest } from "../../interfaces/JenisDokumen";
import { getJenisDokumenAsync, selectJenisDokumen } from "../../reducers/jenisDokumen/jenisDokumen.actions";
import { getStatusLabel } from "../../store/helpers";
import { PermissionMenuName } from "../../interfaces/UserRole";
import Datatables from "../../layouts/Datatables";
// @ts-ignore
import { MUIDataTableMeta } from "mui-datatables";
import { Tooltip } from '@mui/material';
import Zoom from '@mui/material/Zoom';

export const JenisDokumenListPage = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const isLoading = useSelector((state: RootState) => state.jenisDokumen.isLoading);
  const errorMessage = useSelector(
    (state: RootState) => state.jenisDokumen.errorMessage
  );
  const listJenisDokumen = useSelector((state: RootState) => state.jenisDokumen.listJenisDokumen);
  const role = useSelector((state: RootState) => state.authorization.systemAccess[PermissionMenuName.masterData].ACCESS);

  useEffect(() => {
    dispatch(getJenisDokumenAsync.request({}));
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const createJenisDokumen = () => {
    dispatch(selectJenisDokumen(null));
    history.push(`/jenis-dokumen/create`);
  }

  const editJenisDokumen = (jenisDokumen: JenisDokumen) => {
    dispatch(selectJenisDokumen(jenisDokumen));
    history.push(`/jenis-dokumen/${jenisDokumen.DOK_JENIS_ID}`);
  }

  const refresh = () => {
    if (isLoading) return;
    dispatch(getJenisDokumenAsync.request({}));
  }

  const getJenisDokumenParentName = (jenisDokumen: JenisDokumenRequest) => {
    const parentDetail = jenisDokumen.DOK_JENIS_PARENT_DETAIL;
    if (parentDetail) {
      return parentDetail.DOK_JENIS_NAMA;
    } else {
      return 'Tidak memiliki induk';
    }
  }

  const renderJenisDokumen = () => {
    if (errorMessage) {
      return (
        // <tr>
        //   <td colSpan={4} style={{textAlign: 'center'}}>
        //   Terdapat kesalahan dalam memuat data: <b>{errorMessage}</b><br/><button className="btn btn-primary btn-xs" onClick={refresh}>Coba Perbaharui Halaman</button>
        //   </td>
        // </tr>

        <div style={{textAlign: 'center'}}>
          Terdapat kesalahan dalam memuat data: <b>{errorMessage}</b><br/><button className="btn btn-primary btn-xs" onClick={refresh}>Coba Perbaharui Halaman</button>
        </div>
      )
    }

    if (isLoading) {
      return (
        // <tr>
        //   <td colSpan={4} style={{textAlign: 'center'}}>
        //     Sedang memuat data &nbsp; <i className="fa fa-refresh fa-spin"></i>
        //   </td>
        // </tr>

        <div style={{textAlign: 'center'}}>
          Sedang memuat data &nbsp; <i className="fa fa-refresh fa-spin"></i>
        </div>
      );
    }

    if (listJenisDokumen.length === 0) {
      return (
        // <tr>
        //   <td colSpan={4} style={{textAlign: 'center'}}>
        //     Data tidak ditemukan: &nbsp; <button className="btn btn-primary btn-xs" onClick={refresh}>Coba Perbaharui Halaman</button>
        //   </td>
        // </tr>

        <div style={{textAlign: 'center'}}>
          Data tidak ditemukan: &nbsp; <button className="btn btn-primary btn-xs" onClick={refresh}>Coba Perbaharui Halaman</button>
        </div>
      );
    }
    
    // return listJenisDokumen.map((jenisDokumen, index) => {
    //   return (
    //     <tr key={jenisDokumen.DOK_JENIS_ID}>
    //       <td>{index + 1}</td>
    //       <td>{jenisDokumen.DOK_JENIS_NAMA}</td>
    //       <td>{jenisDokumen.DOK_JENIS_KODE}</td>
    //       <td dangerouslySetInnerHTML={{ __html: getJenisDokumenParentName(jenisDokumen) }}></td>
    //       <td>{getStatusLabel(jenisDokumen.STATUS)}</td>
    //       <th>
    //         <button className="btn btn-primary btn-xs" onClick={() => editJenisDokumen(jenisDokumen)}>
    //           <i className="fa fa-edit" aria-hidden="true"></i>
    //         </button>
    //       </th>
    //     </tr>
    //   );
    // })

    const items = listJenisDokumen.map((item, index) => ({
      NO: index + 1,
      id: item.DOK_JENIS_ID,
      STATUS_DESC: getStatusLabel(item.STATUS),
      INDUK: getJenisDokumenParentName(item),
      ...item,
    }));

    const getHeaderProps = (width: string, padding: string) => {
      return {
        style: {
          width: width,
          maxWidth: width,
          padding: padding
        },
      };
    };

    const getCellProps = (width: string, padding: string, align: string) => {
      return {
        style: {
          width: width,
          maxWidth: width,
          padding: padding,
          fontSize: '12px',
          textAlign: `${align}`
        },
      };
    };

    const actionRenderer = (value: any, tableMeta: MUIDataTableMeta) => {
      const row = items[tableMeta.rowIndex];

      return (
        <div style={{display: 'flex'}}>
          <Tooltip title="Ubah"
            slots={{
              transition: Zoom,
            }} 
            componentsProps={{
              tooltip: {
                sx: {
                  fontSize: '11px'
                },
              },
            }}>
            <button className="btn btn-primary btn-xs" onClick={() => editJenisDokumen(row)}>
              <i className="fa fa-edit" aria-hidden="true"></i>
            </button>
          </Tooltip>
        </div>
      );
    }

    const columns = [
      {
        name: "NO",
        label: "No",
        options: {
          filter: false,
          sort: true,
          setCellHeaderProps: () => getHeaderProps('50px', '5px 0 5px 0'),
          setCellProps: () => getCellProps('50px', '5px 0 5px 10px', 'left')
        },
      },
      {
        name: "DOK_JENIS_NAMA",
        label: "Nama",
        options: {
          filter: true,
          sort: true,
          setCellHeaderProps: () => getHeaderProps('35%', '5px 0 5px 0'),
          setCellProps: () => getCellProps('35%', '5px 0 5px 10px', 'left')
        }
      },
      {
        name: "DOK_JENIS_KODE",
        label: "Kode",
        options: {
          filter: true,
          sort: true,
          setCellHeaderProps: () => getHeaderProps('10%', '5px 0 5px 0'),
          setCellProps: () => getCellProps('10%', '5px 0 5px 10px', 'left')
        }
      },
      {
        name: "INDUK",
        label: "Induk",
        options: {
          filter: true,
          sort: true,
          setCellHeaderProps: () => getHeaderProps('35%', '5px 0 5px 0'),
          setCellProps: () => getCellProps('35%', '5px 0 5px 10px', 'left'),
          customBodyRender: (value: any) => (
            value !== 'Tidak memiliki induk' ? <b>{value}</b> : value
          )
        }
      },
      {
        name: "STATUS_DESC",
        label: "Status",
        options: {
          filter: true,
          sort: true,
          setCellHeaderProps: () => getHeaderProps('10%', '5px 0 5px 0'),
          setCellProps: () => getCellProps('10%', '5px 0 5px 10px', 'left')
        }
      },
      { 
        name: "actions",
        label: " ",
        options: {
          filter: false,
          sort: false,
          download: false,
          setCellHeaderProps: () => getHeaderProps('9%', '5px 0 5px 0'),
          setCellProps: () => getCellProps('9%', '5px 0 5px 10px', 'left'),
          customBodyRender: actionRenderer
        },
      }
    ];
    
    return (
      <Datatables data={items} col={columns} title={'Daftar Jenis Dokumen'} />
    )
  }

  return (
    <JenisDokumenListPageWrapper>
      <section className="content">
        <div className="row">
          <div className="col-lg-8">
            <div className="box">
              <div className="box-header" style={{marginTop: '4px'}}>
                <h3 className="box-title">Daftar Jenis Dokumen</h3>

                <div className="box-tools">
                  <button
                    disabled={!role.create}
                    className="btn btn-primary"
                    onClick={createJenisDokumen}
                  >
                    Tambah Baru
                  </button>
                </div>
              </div>
              {/* <div className="box-body table-responsive no-padding">
                <table className="table table-hover">
                  <thead>
                    <tr>
                      <th>#</th>
                      <th>Nama</th>
                      <th>Kode</th>
                      <th>Induk</th>
                      <th>Status</th>
                      <th></th>
                    </tr>
                  </thead>
                  <tbody>
                    { renderJenisDokumen() }
                  </tbody>
                </table>
              </div> */}
              <div style={{padding: '0 10px 10px 10px'}}>
                { renderJenisDokumen() }
              </div>
            </div>
          </div>
        </div>
      </section>
    </JenisDokumenListPageWrapper>
  );
};

const JenisDokumenListPageWrapper = styled.div``;
